/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：812
 */

module.exports = {
  wrapper: "MiniConsole_wrapper__22Tby",
  errorWarning: "MiniConsole_errorWarning__2yXrL",
  iconConsole: "MiniConsole_iconConsole__2KnRq",
  errorBox: "MiniConsole_errorBox__mu8gq",
  warningBox: "MiniConsole_warningBox__9pgHu"
}
